import { BusinessFetchAPI } from '../api/Business';
async function validDomain() {
    let businessCode = "";

    //Function to initialize the data
    const handlerInit = async () => {
        //We get the url of the page and remove the 'www.' prefix if present
        let url = (new URL(window.location.href).hostname || '')
            .toLowerCase()
            .replace(/^www\./, '');

        //For development purposes only
        /*    let url = "donlee.ecommerce.smartpay.ai".toLowerCase()
              .replace(/^www\./, '');  */
        //let url = "panamaconventions.ecommerce.smartpay.ai";
        //console.log("URL:", url);
        //We check if the url is a subdomain of smartpay
        const isSmartpaySubdomain = url.includes('.ecommerce.smartpay.');

        //console.log("isSmartpaySubdomain:", isSmartpaySubdomain);
        //If the url is a subdomain of smartpay we get the last part of the url
        if (isSmartpaySubdomain) {
            //We get the business info in base of the subdomain
            let subdomain = url.split('.')[0];
            try {
                const response = await BusinessFetchAPI.getBusinessBySubdomain(subdomain);
                let business = response.data.business;
                localStorage.setItem('business', JSON.stringify(business));
                businessCode = business.code;
                // Actualiza el título de la página con el nombre del negocio
                if (business && business.name) {
                    document.title = business.name;
                    if (business.name === "PASTRY NATION S.A.") {
                        localStorage.setItem("theme", "dark");
                    }
                }
            } catch (err) {
                //console.log(err);
                businessCode = undefined;

            }
        } else {
            //We get the business info in base of the last part of the url
            try {
                const response = await BusinessFetchAPI.getBusinessByDomain(url);
                let business = response.data.business;
                localStorage.setItem('business', JSON.stringify(business));
                businessCode = business.code;
            } catch (err) {
                //console.log(err);
                businessCode = undefined;
            }
        }
    }

    await handlerInit();
    return businessCode;

}

export default validDomain
